<template>
    <div class="c-row">
        <div class="c-tr">
            <location-badge
                class="c-td is-1"
                :logo="$options.LOGOS.EP"
                :location="location"
            />

            <location-badge
                v-if="replicatedLocation"
                class="c-td is-2"
                :logo="$options.LOGOS.KPL"
                :location="replicatedLocation"
            />
            <div v-else class="c-td">
                <the-dropdown
                    class="mb-0"
                    text="Wybierz sklep z Kaucyjni.pl"
                    :show-legend="false"
                    :options="dropdownOptions"
                    :selected-option="selectedOption"
                    @change="$emit('select', $event)"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { LOGOS } from '@/utils/constants/drs/logos'

export default {
    LOGOS,

    props: {
        location: {
            type: Object,
            required: true
        },

        replicatedLocation: {
            type: Object,
            default: null
        },

        options: {
            type: Array,
            default: () => []
        },

        selectedOption: {
            type: [String, Number],
            default: null
        }
    },

    computed: {
        dropdownOptions() {
            return this.options.map(option => ({
                value: option.id,
                label: option.name,
                disabled: option.disabled
            }))
        }
    }
}
</script>

<style lang="scss">
@import '@/styles/_custom.scss';
@import '~bootstrap/scss/mixins';
@import './location-mapping-table';

.location-mapping-table {
    @extend .location-mapping-table-base;

    .c-td {
        --width: 50%;
    }
}
</style>
